export default __webpack_public_path__ + "static/media/bday2.38f70b6a.jpg";